import React ,{useState, useEffect, useRef} from 'react'
import { createPortal } from 'react-dom';
import { jwtDecode } from 'jwt-decode';
import TranslateInput, {TranslateLanguage} from '../components/KeywordTranslator';
import '../style.css';
import EverestAudioAttribution from './EverestAudioAttribution';
import ResponsiveAudioPlayer from './ResponsiveAudioPlayer';
import { resolveChapterAudio } from './chapterAudioResolver';
import BibleNoteDialog from './BibleNoteDialog';
import {
  createVerseTimingFile,
  loadVerseAudioTimings,
  normaliseTimings,
  saveVerseAudioTimings,
  saveVerseAudioTimingsToServer,
} from './verseAudioTimings';

import {
    EuiText,
    EuiTextColor,
    EuiSelect, 
    EuiSpacer,
    EuiFlyoutBody,
    EuiFlyoutHeader,
    EuiFlyoutFooter,
    EuiFlexGroup,
    EuiFlexItem,
    EuiTitle,
    EuiButton,
    EuiButtonIcon
  } from '@elastic/eui';

function VerseModal(props) {
    // var versenumber =  props.versenumber;
    var versenumber = 9999;
    const [footerAudioTarget, setFooterAudioTarget] = useState(null);
    const [footerNoteTarget, setFooterNoteTarget] = useState(null);
    var language = props.language;
    useEffect(() => {
      if (!props.useFooterAudioControls || !props.footerAudioTargetId) return;
      setFooterAudioTarget(document.getElementById(props.footerAudioTargetId));
    }, [props.useFooterAudioControls, props.footerAudioTargetId]);
    useEffect(() => {
      if (!props.footerNoteTargetId) return;
      setFooterNoteTarget(document.getElementById(props.footerNoteTargetId));
    }, [props.footerNoteTargetId]);
    const isAdmin = (() => {
      try {
        const token = sessionStorage.getItem('token') || localStorage.getItem('token');
        if (token) {
          const decoded = jwtDecode(token);
          const role = decoded?.role
            || decoded?.Role
            || decoded?.['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
          if (String(role || '').toLowerCase() === 'admin') return true;
        }

        const storedUser = sessionStorage.getItem('user') || localStorage.getItem('user');
        const user = storedUser ? JSON.parse(storedUser) : null;
        const role = user?.role ?? user?.Role;
        return String(role || '').toLowerCase() === 'admin' || Number(role) === 1;
      } catch {
        return false;
      }
    })();
    var selectedVerse = props.selectedVerse;
    const [noteVerse, setNoteVerse] = useState(Number(props.selectedVerse) || 1);
    const [isBibleNoteOpen, setIsBibleNoteOpen] = useState(false);
    const [resultVerse, setResultVerse] = useState("");
    const [version, setVersion] = useState("unv");
    const [book, setBook] = useState(props.book);
    const [bookname, setBookName] = useState(props.bookname);
    const [chapter, setChapter] = useState(props.chapter);
    const [playKey, setPlayKey] = useState("")
    const [play, setPlay] = useState(false);
    const [audioStatus, setAudioStatus] = useState('checking');  // checking | ready | missing | error
    const [audioSource, setAudioSource] = useState(''); // local | everest
    const audioRef = useRef(null);
    const verseContentRef = useRef(null);
    const [verseTimings, setVerseTimings] = useState([]);
    const [activeAudioVerse, setActiveAudioVerse] = useState(null);
    const [isTimingEditorOpen, setIsTimingEditorOpen] = useState(false);
    const [timingVerse, setTimingVerse] = useState('1');
    const [chapterVerseNumbers, setChapterVerseNumbers] = useState([]);
    const [timingSaveStatus, setTimingSaveStatus] = useState('idle');
    const [timingSaveMessage, setTimingSaveMessage] = useState('');
    const [prevButton, setPrevButton] = useState(true);
    const [nextButton, setNextButton] = useState(true);
    const playApiURL = process.env.REACT_APP_PlayApiURL;
    const apiKey = process.env.REACT_APP_APIKey;
    const [loading, setLoading] = useState(true); // 初始化为加载状态

    //const apiURL = "https://bible.fhl.net/json/qb.php?"
    const apiURL = "/api/bible/verses?"
    const options = [
      { value: 'unv', text: '和合本 (CUV)' },
      // { value: 'rcuv', text: '和合本2010 (RCUV)' },
      // { value: 'cumv', text: '官話和合本 (CYMV)' },
      // { value: 'tcv2019', text: '現代中文譯本2019版 (TCV2019)' },
      { value: 'lzz', text: '呂振中譯本 (LZZ)' },   
      // { value: 'cuwv', text: '文理和合本 （CUWV)' },   
      // { value: 'jp', text: '日語聖經 （JP)' },
      { value: 'kjv', text: 'King James (KJV)' },
      { value: 'bbe', text: 'Bible in Basic English (BBE)'}
      // { value: 'esv', text: 'English Standard Version (ESV)' },
      // { value: 'asv', text: 'American Standard Version (ASV)' },
      // { value: 'web', text: 'World English Bible (WEB)' }
    ];
    const bookMax =[{book: "創", max:50},{book: "出", max:40},{book: "利", max:27},{book: "民", max:36},{book: "申", max:34},{book: "書", max:24},{book: "士", max:21},{book: "得", max:4},
                  {book: "撒上", max:31},{book: "撒下", max:24},{book: "王上", max:22},{book: "王下", max:25},{book: "代上", max:29},{book: "代下", max:36},{book: "拉", max:10},{book: "尼", max:13},
                  {book: "斯", max:10},{book: "伯", max:42},{book: "詩", max:150},{book: "箴", max:31},{book: "傳", max:12},{book: "歌", max:8},{book: "賽", max:66},{book: "耶", max:52},{book: "哀", max:5},
                  {book: "結", max:48},{book: "但", max:12},{book: "何", max:14},{book: "珥", max:3},{book: "摩", max:9},{book: "俄", max:1},{book: "拿", max:4},{book: "彌", max:7},{book: "鴻", max:3},
                  {book: "哈", max:3},{book: "番", max:3},{book: "該", max:2},{book: "亞", max:14},{book: "瑪", max:4},{book: "太", max:28},{book: "可", max:16},{book: "路", max:24},{book: "約", max:21},
                  {book: "徒", max:28},{book: "羅", max:16},{book: "林前", max:16},{book: "林後", max:13},{book: "加", max:6},{book: "弗", max:6},{book: "腓", max:4},{book: "西", max:4},{book: "帖前", max:5},
                  {book: "帖後", max:3},{book: "提前", max:6},{book: "提後", max:4},{book: "多", max:3},{book: "門", max:1},{book: "來", max:13},{book: "雅", max:5},{book: "彼前", max:5},
                  {book: "彼後", max:3},{book: "約一", max:5},{book: "約二", max:1},{book: "約三", max:1},{book: "猶", max:1},{book: "啟", max:22}]

    const [value, setValue] = useState(options[0].value);

    useEffect(()=>{
        loadVerse();
        loadPlayKey(chapter);
    },[])

    useEffect(() => {
      if (!verseContentRef.current) return;
      const verses = verseContentRef.current.querySelectorAll('[data-verse-number]');
      verses.forEach(element => element.classList.remove('audio-active-scripture-verse'));
      if (!activeAudioVerse) return;

      const activeVerse = verseContentRef.current.querySelector(
        `[data-verse-number="${activeAudioVerse}"]`
      );
      if (!activeVerse) return;
      activeVerse.classList.add('audio-active-scripture-verse');
      activeVerse.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, [activeAudioVerse, resultVerse, version]);
 
    const loadVerse = async () => {
        setLoading(true); // 开始加载时设置为 true
        var resultVerseText = "";

        await fetch(apiURL + "version=" + version + "&chineses=" + book + "&chap=" + chapter)
        .then(function(response){
            return(response.json())
        })
        .then(function(data){
            if (data.errors) {
              console.error("Validation error:", data.errors);
              return; // Exit early if there is a validation error
            }
            var results = JSON.parse(JSON.stringify(data))
            setChapterVerseNumbers(results.record.map(record => Number(record.sec)));
            for(var i = 0; i < results.record.length; i++) {
              if(versenumber != results.record[i].sec) {
                resultVerseText = resultVerseText + "<EuiText>" + results.record[i].sec + " " + TranslateLanguage(language,results.record[i].bible_text)  + "</EuiText><br/>"
              }else{
                resultVerseText = resultVerseText + "<EuiText><em>" + results.record[i].sec + " " + TranslateLanguage(language,results.record[i].bible_text)  + "</em></EuiText><br/>"
              }
            }
            //console.log(JSON.stringify(results, null, 2))  
        })

        setResultVerse(resultVerseText);
        setLoading(false); // 数据加载完成后设置为 false
        var getBook = book;
        var maxVerse = bookMax.find( ({ book }) => book === getBook );  
        (maxVerse.max < (parseInt(chapter) +1)) && setNextButton(false);
        ((parseInt(chapter) -1) <= 0) && setPrevButton(false);
    }

    const apiResult = async (version, selectChapter) =>{
      var apiVerseResult;
      await fetch(apiURL + "version=" + version + "&chineses=" + book + "&chap=" + selectChapter)
      .then(function(response){
          return(response.json())
      })
      .then(function(data){
          apiVerseResult = JSON.parse(JSON.stringify(data))
          //console.log(JSON.stringify(apiVerseResult, null, 2))  
      })
      return apiVerseResult;
    }

    const getAllResult =(version, selectChapter) =>{
      return Promise.all([apiResult("unv", selectChapter), apiResult(version,selectChapter)])
    }

    const onChange = (e) => {
      setValue(e.target.value);
      setVersion(e.target.value)
      var selectVersion = e.target.value;
      refreshResult(selectVersion, chapter);
    }

    const refreshResult = (selectVersion, selectChapter)=>{
      var showBaseVersion = (selectVersion != "unv") ? "(CUV)" : "";
      var resultVerseText = "";
      setLoading(true);
      getAllResult(selectVersion, selectChapter)
        .then(([baseVerseResult, compVerseResult]) => { 
          setChapterVerseNumbers(baseVerseResult.record.map(record => Number(record.sec)));
          for(var i = 0; i < baseVerseResult.record.length; i++) {
            if(versenumber != baseVerseResult.record[i].sec) {
              resultVerseText = resultVerseText + "<EuiText>" + baseVerseResult.record[i].sec + " " + TranslateLanguage(language,baseVerseResult.record[i].bible_text)  + showBaseVersion + "</EuiText><br/>";
              resultVerseText = (selectVersion != "unv") ? resultVerseText + "<EuiText>" +  compVerseResult.record[i].sec + " " + TranslateLanguage(language,compVerseResult.record[i].bible_text)  + " (" + selectVersion.toUpperCase()  + ") " + "</EuiText><br/><br/>" : resultVerseText;
            }else{
              resultVerseText = resultVerseText + "<EuiText><em>" + baseVerseResult.record[i].sec + " " + TranslateLanguage(language,baseVerseResult.record[i].bible_text)  + showBaseVersion + "</em></EuiText><br/>";
              resultVerseText = (selectVersion != "unv") ? resultVerseText + "<EuiText><em>" + compVerseResult.record[i].sec + " " + TranslateLanguage(language,compVerseResult.record[i].bible_text)  +  " (" + selectVersion.toUpperCase() + ") " + "</em></EuiText><br/><br/>" : resultVerseText; 
            }
        }
          setResultVerse(resultVerseText) 
          setLoading(false);
        })
    
    };   
    
    const nextChapter=(continuePlaying = false)=>{
      var newChapter = (parseInt(chapter) +1).toString();
      var getBook = book;
      var maxVerse = bookMax.find( ({ book }) => book === getBook);
      (maxVerse.max < (parseInt(chapter) +2)) && setNextButton(false);
      setPrevButton(true);
      setChapter(newChapter);
      props.onChapterChange(newChapter);
      refreshResult(version, newChapter);
      setPlay(false)
      loadPlayKey(newChapter, continuePlaying === true);
      versenumber = 9999;
    }

    const prevChapter=()=>{
      var newChapter = (parseInt(chapter)-1).toString();
      ((parseInt(chapter) -2) <= 0) && setPrevButton(false);
      setNextButton(true);
      setChapter(newChapter);
      props.onChapterChange(newChapter);
      refreshResult(version, newChapter);
      setPlay(false)
      loadPlayKey(newChapter);
      versenumber = 9999;
    }

    // const loadPlayKey = async (selectChapter) => {
    //   await fetch(playApiURL,{
    //     method:"POST",
    //     headers:{
    //         "Content-Type":"application/json, charset=UTF-8",
    //         "Authorization": "Bearer search-" + apiKey
    //     },
    //     body:JSON.stringify({
    //         query:"",
    //         filters: {"all": [{book: book}, {chapter: selectChapter}]}, 
    //         page:{size: 1000},
    //         sort:{id: "asc"}
    //     })
    // })
    // .then(function(response){
    //     return(response.json())
    // })
    // .then(function(data){
    //     var results = JSON.parse(JSON.stringify(data));
    //     if (results.results){
    //       var resultKey = results.results[0].key.raw;
    //       if(!resultKey){resultKey = results.results[0].key2.raw;}
    //        setPlayKey("http://docs.google.com/uc?export=open&id=" + resultKey);   
    //     }
    // })
    // }
    const loadPlayKey = async (selectChapter, continuePlaying = false) => {
      setPlay(false);
      setPlayKey('');
      setAudioStatus('checking');
      setAudioSource('');
      setVerseTimings([]);
      setActiveAudioVerse(null);
      setIsTimingEditorOpen(false);
      setTimingSaveStatus('idle');
      setTimingSaveMessage('');

      try {
        const audio = await resolveChapterAudio({ book, chapter: selectChapter });

        if (audio) {
          setPlayKey(audio.url);
          setAudioSource(audio.source);
          setVerseTimings(await loadVerseAudioTimings({ book, chapter: selectChapter }));
          setAudioStatus('ready');
          setPlay(continuePlaying);
          return;
        }

        setAudioStatus('missing');
      } catch (error) {
        console.error('Failed to check audio resource:', error);
        setPlay(false);
        setPlayKey('');
        setAudioStatus('error');
      }
    };

    // const onPlay = (e) => {
    //   setPlay(true)
    // };

    const handleAudioTimeUpdate = event => {
      if (!verseTimings.length) return;
      const currentTiming = verseTimings.reduce(
        (current, timing) => (timing.start <= event.currentTarget.currentTime ? timing : current),
        null
      );
      setActiveAudioVerse(currentTiming?.verse || null);
    };

    const seekAudioToVerse = (audioElement, verseNumber) => {
      const verse = Number.parseInt(verseNumber, 10);
      if (!audioElement || !Number.isInteger(verse)) return;
      if (verse === 1) {
        audioElement.currentTime = 0;
        setActiveAudioVerse(null);
        return;
      }
      if (!verseTimings.length) return;
      const timing = verseTimings.find(item => item.verse === verse);
      if (!timing) return;
      audioElement.currentTime = timing.start;
      setActiveAudioVerse(verse);
    };

    const saveTimingDraft = timings => {
      const saved = saveVerseAudioTimings({ book, chapter, timings });
      setVerseTimings(saved);
      setTimingSaveStatus('dirty');
      setTimingSaveMessage('');
      return saved;
    };

    const markCurrentVerseTime = () => {
      const currentTime = audioRef.current?.currentTime;
      const verse = Number(timingVerse);
      if (!Number.isFinite(currentTime) || !Number.isInteger(verse) || verse < 1) return;

      saveTimingDraft([
        ...verseTimings.filter(timing => timing.verse !== verse),
        { verse, start: Number(currentTime.toFixed(3)) },
      ]);
      const nextVerse = chapterVerseNumbers.find(number => number > verse);
      if (nextVerse) setTimingVerse(String(nextVerse));
      setActiveAudioVerse(verse);
    };

    const saveTimingsToServer = async () => {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      if (!token || !verseTimings.length) return;

      setTimingSaveStatus('saving');
      setTimingSaveMessage('');
      try {
        const saved = await saveVerseAudioTimingsToServer({
          book,
          chapter,
          timings: verseTimings,
          token,
        });
        setVerseTimings(saved);
        setTimingSaveStatus('saved');
        setTimingSaveMessage(TranslateLanguage(language, '已保存到服務器。'));
      } catch (error) {
        setTimingSaveStatus('error');
        setTimingSaveMessage(error?.message || TranslateLanguage(language, '保存到服務器失敗。'));
      }
    };

    const downloadTimingFile = () => {
      const content = createVerseTimingFile({ book, chapter, timings: verseTimings });
      const file = new Blob([content], { type: 'application/json' });
      const url = window.URL.createObjectURL(file);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${String(chapter).padStart(3, '0')}.json`;
      link.click();
      window.URL.revokeObjectURL(url);
    };

    const importTimingFile = async event => {
      const [file] = Array.from(event.target.files || []);
      if (!file) return;
      try {
        saveTimingDraft(normaliseTimings(JSON.parse(await file.text())));
      } catch {
        setTimingSaveStatus('error');
        setTimingSaveMessage(TranslateLanguage(language, '標注 JSON 格式不正確。'));
      } finally {
        event.target.value = '';
      }
    };

    const VerseComponent = ({ resultVerse, selectedVerse, activeAudioVerse, onVerseClick, selectVersion }) => {

        // 根据 `selectVersion` 值选择分割方法
        const verses = selectVersion !== "unv" 
            ? resultVerse.split(/<br\/><br\/>/)  // 双 `<br/><br/>` 分割
            : resultVerse.split(/<br\/>/);       // 单 `<br/>` 分割

        return (
            <EuiText>
                {verses.map((verse, index) => {
                    const verseNumber = index + 1;
                    const isAudioActive = activeAudioVerse === verseNumber;
                    const cleanedVerse = verse.replace(/<EuiText>|<\/EuiText>/g, '');
                    // 如果分割方式是双 `<br/><br/>` 则每节可能包含多个版本，将这些版本分割
                    const verseVersions = selectVersion !== "unv"
                        ? cleanedVerse.split(/<br\/>/).map(v => v.trim())
                        : [cleanedVerse];  // 单一版本时保持整个节为一个段落
                    return (
                        <span
                            key={index}
                            data-verse-number={verseNumber}
                            style={{
                                cursor: 'pointer',
                                display: 'block',
                                marginBottom: '8px',
                                backgroundColor: isAudioActive ? '#CDEEFB' : selectedVerse === verseNumber ? '#FFF9C4' : 'transparent',
                                color: isAudioActive ? '#003B70' : selectedVerse === verseNumber ? '#000' : '#333',
                                fontWeight: isAudioActive || selectedVerse === verseNumber ? 'bold' : 'normal',
                                padding: '8px', // 增加内边距
                                borderRadius: '8px', // 为高亮效果添加更明显的圆角
                                border: isAudioActive ? '2px solid #0077A8' : selectedVerse === verseNumber ? '2px solid #FFB300' : 'none'
                            }}
                            onClick={() => {
                                onVerseClick(verseNumber); // 触发回调函数
                            }}
                        >
                        {verseVersions.map((version, idx) => (
                            <span 
                                 key={idx} 
                                 style={{ display: 'block', marginBottom: '4px' } }
                                 dangerouslySetInnerHTML={{ __html: version }} // 直接渲染 HTML
                            />
                        ))}
                        </span>
                    );
                })}
            </EuiText>
        );
    };

    const handleVerseClick = (verseNumber) => {
        setNoteVerse(verseNumber);
        if (audioRef.current) seekAudioToVerse(audioRef.current, verseNumber);
        props.onVerseChange(verseNumber);
    };

    return (
        <>
           {loading ? (
                <p>{TranslateLanguage(language,"正在加载中...")}</p> // 加载时显示提示文本
            ) : (
                <>
          <EuiFlyoutHeader hasBorder>
            <EuiFlexGroup wrap={false} gutterSize="xs" responsive={false}>
              {/* <EuiFlexItem grow={false}>
              <EuiTitle size="m">
                <h2 id="flyoutTitle">{TranslateLanguage(language,bookname)} {chapter}</h2>
              </EuiTitle>
              </EuiFlexItem> */}
              <EuiFlexItem><EuiSpacer size="l"></EuiSpacer></EuiFlexItem>
              <EuiFlexItem grow={false}>
              {(prevButton) && <EuiButtonIcon
                display="base"
                iconType="arrowLeft"
                size="s"
                aria-label="上一章"
                onClick={()=> prevChapter()}
              />}
              </EuiFlexItem>
              <EuiFlexItem grow={false}><EuiSpacer size="m" /></EuiFlexItem>
              <EuiFlexItem grow={false} >           
              {(nextButton) && <EuiButtonIcon
                display="base"
                iconType="arrowRight"
                size="s"
                aria-label="下一章"
                onClick={()=> nextChapter()}
              />}
              </EuiFlexItem>
        
              </EuiFlexGroup>
          </EuiFlyoutHeader>
            <EuiFlyoutBody>
              <EuiText>
                {TranslateLanguage(
                  language,
                  '對照經文版本：'
                )}
              </EuiText>

              <EuiSpacer size="xs" />

              <EuiFlexGroup
                gutterSize="s"
                alignItems="center"
                responsive={false}
                className="verse-toolbar"
              >
                {/* 对照版本 */}
                <EuiFlexItem>
                  <EuiSelect
                    id="selectVersion"
                    options={options}
                    value={value}
                    onChange={(e) => onChange(e)}
                    fullWidth
                  />
                </EuiFlexItem>

              </EuiFlexGroup>
                {audioStatus === 'checking' && (
                  <>
                    <EuiSpacer size="xs" />

                    <EuiText
                      size="xs"
                      color="subdued"
                    >
                      {TranslateLanguage(
                        language,
                        '正在檢查朗讀資源……'
                      )}
                    </EuiText>
                  </>
                )}

                {audioStatus === 'missing' && (
                  <>
                    <EuiSpacer size="xs" />
                    <EuiText size="xs" color="subdued">
                      {TranslateLanguage(language, '本章暫無朗讀資源')}
                    </EuiText>
                  </>
                )}

                {audioStatus === 'ready' && audioSource === 'everest' && (
                  <>
                    <EuiSpacer size="xs" />
                    <EverestAudioAttribution language={language} />
                  </>
                )}

                {audioStatus === 'ready' && audioSource === 'local' && (
                  <>
                    <EuiSpacer size="xs" />
                    <EuiText size="xs" color="subdued">
                      {TranslateLanguage(language, '音頻由小牧人有聲聖經提供。')}
                    </EuiText>
                  </>
                )}

                {audioStatus === 'error' && (
                  <>
                    <EuiSpacer size="xs" />

                    <EuiText
                      size="s"
                      color="danger"
                    >
                      {TranslateLanguage(
                        language,
                        '朗讀資源加載失敗，請稍後重試'
                      )}
                    </EuiText>
                  </>
                )}

                {!props.useFooterAudioControls && audioStatus === 'ready' && (
                  <>
                    <EuiSpacer size="xs" />

                    <div className="verse-audio-container">
                      <ResponsiveAudioPlayer
                        ref={audioRef}
                        key={playKey}
                        src={playKey}
                        autoPlay={play}
                        preload="metadata"
                        controlsList="nodownload"
                        className="verse-audio-player"
                        onLoadedMetadata={event => seekAudioToVerse(event.currentTarget, selectedVerse)}
                        onTimeUpdate={handleAudioTimeUpdate}
                        onSeeked={handleAudioTimeUpdate}
                        onEnded={() => {
                          setActiveAudioVerse(null);
                          if (nextButton) nextChapter(true);
                        }}
                        onError={() => {
                          setPlay(false);
                          setAudioStatus('error');
                        }}
                      >
                        {TranslateLanguage(
                          language,
                          '您的瀏覽器不支持音頻播放'
                        )}
                      </ResponsiveAudioPlayer>
                    </div>
                  </>
                )}

                {props.useFooterAudioControls && footerAudioTarget && createPortal(
                  audioStatus === 'ready' ? (
                    <div className="verse-audio-container verse-footer-audio-container">
                      <ResponsiveAudioPlayer
                        ref={audioRef}
                        key={playKey}
                        src={playKey}
                        autoPlay={play}
                        preload="metadata"
                        controlsList="nodownload"
                        className="verse-audio-player"
                        onLoadedMetadata={event => seekAudioToVerse(event.currentTarget, selectedVerse)}
                        onTimeUpdate={handleAudioTimeUpdate}
                        onSeeked={handleAudioTimeUpdate}
                        onEnded={() => {
                          setActiveAudioVerse(null);
                          if (nextButton) nextChapter(true);
                        }}
                        onError={() => {
                          setPlay(false);
                          setAudioStatus('error');
                        }}
                      >
                        {TranslateLanguage(language, '您的瀏覽器不支持音頻播放')}
                      </ResponsiveAudioPlayer>
                    </div>
                  ) : null,
                  footerAudioTarget
                )}

                {isAdmin && audioStatus === 'ready' && (
                  <>
                    <EuiSpacer size="xs" />
                    <div className="verse-audio-sync-status">
                      <span>
                        {verseTimings.length
                          ? TranslateLanguage(language, `已載入 ${verseTimings.length} 節同步標注；可播放核對並修正。`)
                          : TranslateLanguage(language, '本章尚未有逐節同步標注。')}
                      </span>
                      <EuiButton
                        size="s"
                        display="empty"
                        onClick={() => setIsTimingEditorOpen(open => !open)}
                      >
                        {TranslateLanguage(language, isTimingEditorOpen ? '完成標注' : '編輯／核對標注')}
                      </EuiButton>
                    </div>
                  </>
                )}

                {isAdmin && isTimingEditorOpen && audioStatus === 'ready' && (
                  <div className="verse-audio-timing-editor">
                    <EuiText size="xs">
                      {TranslateLanguage(language, '播放到該節開始處，選取節數後按「記錄目前時間」。完成後可保存到服務器。')}
                    </EuiText>
                    <EuiFlexGroup gutterSize="s" alignItems="center" responsive={false}>
                      <EuiFlexItem>
                        <EuiSelect
                          aria-label="選擇經文節數"
                          options={chapterVerseNumbers.map(verse => ({ value: String(verse), text: `${verse}` }))}
                          value={timingVerse}
                          onChange={event => setTimingVerse(event.target.value)}
                          fullWidth
                        />
                      </EuiFlexItem>
                      <EuiFlexItem grow={false}>
                        <EuiButton size="s" fill disabled={!playKey} onClick={markCurrentVerseTime}>
                          {TranslateLanguage(language, '記錄目前時間')}
                        </EuiButton>
                      </EuiFlexItem>
                    </EuiFlexGroup>
                    <div className="verse-audio-timing-actions">
                      <EuiButton
                        size="s"
                        fill
                        onClick={saveTimingsToServer}
                        disabled={!verseTimings.length || timingSaveStatus === 'saving'}
                        isLoading={timingSaveStatus === 'saving'}
                      >
                        {TranslateLanguage(language, '保存到服務器')}
                      </EuiButton>
                      <EuiButton size="s" onClick={downloadTimingFile} disabled={!verseTimings.length}>
                        {TranslateLanguage(language, '下載標注 JSON')}
                      </EuiButton>
                      <label className="verse-audio-import-label">
                        {TranslateLanguage(language, '匯入標注 JSON')}
                        <input type="file" accept="application/json,.json" onChange={importTimingFile} />
                      </label>
                    </div>
                    {timingSaveMessage && (
                      <EuiText size="xs" color={timingSaveStatus === 'error' ? 'danger' : 'success'}>
                        <p>{timingSaveMessage}</p>
                      </EuiText>
                    )}
                  </div>
                )}

                <EuiSpacer size="s" />

                {!props.footerNoteTargetId && <button type="button" className="bible-note-trigger" onClick={() => setIsBibleNoteOpen(true)}>
                  {TranslateLanguage(language, '筆記')}
                </button>}

                <div ref={verseContentRef}>
                  <VerseComponent
                    resultVerse={resultVerse}
                    selectedVerse={selectedVerse}
                    activeAudioVerse={activeAudioVerse}
                    onVerseClick={handleVerseClick}
                    selectVersion={version}
                  />
                </div>
              </EuiFlyoutBody>
              {props.footerNoteTargetId && footerNoteTarget && createPortal(
                <EuiButton onClick={() => setIsBibleNoteOpen(true)}>
                  {TranslateLanguage(language, '筆記')}
                </EuiButton>,
                footerNoteTarget
              )}
              {isBibleNoteOpen && <BibleNoteDialog
                book={book} bookName={bookname} chapter={Number(chapter)}
                startVerse={noteVerse} maxVerse={Math.max(...chapterVerseNumbers, 1)}
                scriptureText={verseContentRef.current?.querySelector(`[data-verse-number="${noteVerse}"]`)?.textContent?.trim().slice(0, 4000) || ''}
                onClose={() => setIsBibleNoteOpen(false)}
              />}
          </>
            )}
        </>
    )
}

export default VerseModal
